import { ExternalId } from './ExternalId'
import { Address } from './Address'

import camelCaseKeys from 'camelcase-keys'

export class Profile {
  constructor (params = {}) {
    const {
      id,
      sequence,
      externalIds,
      documents,
      addresses,
      name,
      lastName,
      phoneNumber,
      email,
      dateOfBirth,
      gender,
      languageCode,
      dietRestrictions,
      attributes,
      type,
      typeId,
      category,
      categoryId
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.documents = documents || []
    this.addresses = addresses ? addresses.map(a => new Address(a)) : []
    this.name = name || null
    this.lastName = lastName || null
    this.phoneNumber = phoneNumber || null
    this.email = email || null
    this.dateOfBirth = dateOfBirth || null
    this.gender = gender || null
    this.languageCode = languageCode || null
    this.dietRestrictions = dietRestrictions || null
    this.attributes = attributes || null
    this.typeId = typeId || null
    this.type = type || this.typeId
    this.categoryId = categoryId || null
    this.category = category || this.categoryId
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      name: item.name,
      lastName: item.lastName,
      email: item.email,
      phoneNumber: item.phoneNumber,
      dateOfBirth: item.dateOfBirth,
      gender: item.gender,
      languageCode: item.languageCode,
      typeId: item.typeId,
      categoryId: item.categoryId
    }
  }
}
